module.exports = __webpack_public_path__ + "static/img/home-img4.99d63dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img4.png
// module id = rPoI
// module chunks = 1